// @ts-strict-ignore
import { useState, FC } from 'react'
import { useDispatch } from 'react-redux'
import { ScannerItemType, cleanKeypadItems } from 'mytours-read-common'
import strings from 'mobile_web/strings'
import { IonContent } from '@ionic/react'
import { Button } from '@mytours/components'
import Modal from '../../common/components/modal'
import ScannerComponent from './Scanner'

interface Props {
	qrEnabled: boolean
	keypadEnabled: boolean
	showScanner: boolean
	toggleScannerModal: () => void
	itemId: number
}

const ScannerModal: FC<Props> = ({ qrEnabled, keypadEnabled, showScanner, toggleScannerModal, itemId }: Props) => {
	const [modalDidPresent, setModalDidPresent] = useState<boolean>(false)

	const dispatch = useDispatch()

	if (!qrEnabled && !keypadEnabled) {
		return null
	}

	return (
		<>
			<Modal
				isOpen={showScanner}
				cssClass="scanner-modal"
				onDidDismiss={() => {
					if (keypadEnabled) {
						dispatch(cleanKeypadItems({}))
					}
					showScanner && toggleScannerModal()

					setModalDidPresent(false)
				}}
				onDidPresent={() => {
					setModalDidPresent(true)
				}}
			>
				{modalDidPresent && (
					<IonContent className="scanner-content">
						<Button
							variant="clear"
							onClick={toggleScannerModal}
							className="close-modal-button"
							aria-label={strings.cancel}
						>
							<i className="fal fa-xmark" />
						</Button>
						<ScannerComponent
							isPageContent={true}
							itemType={ScannerItemType.Collection}
							itemId={itemId}
							successCallback={() => showScanner && toggleScannerModal()}
						/>
					</IonContent>
				)}
			</Modal>
		</>
	)
}

export default ScannerModal
